function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.667 2c.368 0 .666.298.666.667v1.562a6 6 0 0110.62 3.022.667.667 0 11-1.322.165A4.668 4.668 0 004.17 5.333H6a.667.667 0 010 1.334H2.667A.667.667 0 012 6V2.667C2 2.298 2.298 2 2.667 2zm-.042 6.005a.667.667 0 01.744.58 4.668 4.668 0 008.461 2.082H10a.667.667 0 010-1.334h3.333c.368 0 .667.299.667.667v3.333a.667.667 0 01-1.333 0v-1.562A6 6 0 012.047 8.75a.667.667 0 01.578-.744z",
  fill: "#6C697B"
});

function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default SvgRefresh;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/refresh.svg
// module id = 1336
// module chunks = 10